// extracted by mini-css-extract-plugin
export default {"title":"index_title_tvlj0","imgMark":"index_imgMark_XFAc0"};